// Lieferanten (/rechnung/lieferanten, nur Billtoro): Antworten des Servers (server/src/modules/rechnungstool/lieferanten.ts)
import { passtZuKontakt, type FirmaSchlagwort, type KontaktDatei, type Person } from './KontaktDaten';

export interface Lieferant {
  id: string;
  nummer: number;
  name: string;
  extra: string | null;
  street: string;
  zip: string;
  city: string;
  country: string;
  // außerhalb der EU: Steuernummer
  vatId: string | null;
  email: string | null;
  phone: string | null;
  iban: string | null;
  // unsere Kundennummer beim Lieferanten
  kundennummerDort: string | null;
  notiz: string | null;
  schlagwoerter: string[];
}

// in der Liste: Suchtext aus den Ansprechpartnern, Zahl der Dateien
export interface LieferantZeile extends Lieferant {
  suchtext: string;
  dateien: number;
}

export interface LieferantenAntwort {
  naechsteNummer: number | null;
  schlagwoerter: FirmaSchlagwort[];
  lieferanten: LieferantZeile[];
}

export interface LieferantAntwort {
  lieferant: Lieferant;
  personen: Person[];
  dateien: KontaktDatei[];
  // höchstens so groß je Datei
  dateienMb: number;
}

export const lieferantenUrl = (firmId: string) => `/api/rechnungstool/${firmId}/lieferanten`;
export const lieferantUrl = (id: string) => `/api/rechnungstool/lieferant/${id}`;

export const lieferantenText = (n: number) => `${n} ${n === 1 ? 'Lieferant' : 'Lieferanten'}`;

// Lieferant zum Getippten (Feld „Von wem?“ bei Ausgaben): Nummer (Anfang), Name, USt-IdNr., Ort, Ansprechpartner und
// Schlagwörter; Namen, die so anfangen, zuerst
export function lieferantSuche(liste: LieferantZeile[], q: string, max = 8): LieferantZeile[] {
  const t = q.trim().toLowerCase();
  if (!t) return [];
  const nr = /^\d+$/.test(t);
  const hits = liste.filter(
    (l) =>
      (nr && String(l.nummer).startsWith(t)) ||
      l.name.toLowerCase().includes(t) ||
      (l.vatId ?? '').toLowerCase().includes(t) ||
      l.city.toLowerCase().includes(t) ||
      passtZuKontakt(l, t),
  );
  const start = (l: LieferantZeile) => (l.name.toLowerCase().startsWith(t) || String(l.nummer) === t ? 0 : 1);
  return hits.sort((a, b) => start(a) - start(b)).slice(0, max);
}
